// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"865c18ea","2484":"865c18ea","2855":"865c18ea","4105":"1f08cf17"}[chunkId] + ".chunk.css";
};